import { z } from 'zod';
import { baseObjectSchema } from '../baseSchemas';

export const getMaterialLastVisitValuesWithConditionsSchema = z.array(
  baseObjectSchema.extend({
    materialId: z.string(),
    material: z.object({
      id: z.string(),
      code: z.string(),
      name: z.string(),
    }),
    competitorId: z.string().optional(),
    competitor: z
      .object({
        id: z.string(),
        code: z.string(),
      })
      .optional(),
    traderSiteId: z.string(),
    traderSite: z.object({
      id: z.string(),
      code: z.string(),
      name: z.string(),
    }),
    alterCodeId: z.string(),
    alterCode: z.object({
      id: z.string(),
      code: z.string(),
      name: z.string(),
    }),
    lastPrice: z.number().optional(),
    lastDate: z.string().optional(),
    alterDescription: z.string().optional(),
    shelf: z.string().optional(),
    faces: z.number().optional(),
    remarks: z.string().optional(),
    havePromo: z.boolean(),
    notExist: z.boolean(),
    customerId: z.string().optional(),
    customer: z
      .object({
        id: z.string(),
        code: z.string(),
        name: z.string(),
      })
      .optional(),
  })
);

export type GetMaterialLastVisitValuesResponse = z.infer<
  typeof getMaterialLastVisitValuesWithConditionsSchema
>;
